const { Pagination } = require("swiper/modules");

const recommeneded_section = document.querySelector('[alternate-products]');
const recommendations_local = localStorage.getItem("recommendations");
const options = {
  rootMargin: '400px'
}

if (recommeneded_section) {
  const observer = new IntersectionObserver(entry => {

    if (entry[0].isIntersecting == true) {

      observer.unobserve(recommeneded_section);

      const recommendationWrapper = document.querySelector('[alternate-products]');
      const productRecommendationsSectionSwiper = document.querySelector('[oos-recommendations]');
      if (productRecommendationsSectionSwiper) {
          const product_id = productRecommendationsSectionSwiper.getAttribute('data-product-id');
          const section_name = "pg-product-recommended-products";
          fetch(window.Shopify.routes.root + `recommendations/products?product_id=${product_id}&limit=10&section_id=${section_name}&intent=related`)
              .then(response => response.text())
              .then((text) => {
                  const html = document.createElement('div');
                  html.innerHTML = text;
                  const card_wrapper = html.querySelector('.recommendations-wrapper');
                  const rec_count = parseInt(card_wrapper.getAttribute('data-rec-count'));

                  if (rec_count === 0) {
                      console.log("No recommendations found");
                      return;
                  }

                  if (productRecommendationsSectionSwiper) {
                      productRecommendationsSectionSwiper.innerHTML = card_wrapper.innerHTML;
                  }

                  // Initialize Swiper after updating the HTML
                  new window.swiper('.alternatives-products-slider', {
                      slidesPerView: 1.2,
                      spaceBetween: 20,
                      loop: true,
                      breakpoints: {
                          768: {
                              slidesPerView: 2,
                              spaceBetween: 20,
                          },
                          1028: {
                              slidesPerView: 4,
                              spaceBetween: 20,
                          },
                          1280: {
                              slidesPerView: 5,
                              spaceBetween: 20,
                          },
                      },
                      navigation: {
                          nextEl: '[alternate-products] .next-btn',
                          prevEl: '[alternate-products] .prev-btn',
                      },
                      pagination: {
                        el: `[alternate-products] .collection-slider-pagination`,
                        type: "fraction",
                      },
                  });

                  recommendationWrapper.classList.add('show');
              })
              .catch(error => {
                  console.error('Error fetching recommendations:', error);
              });
      } else {
          console.log("No product recommendations section found");
      }
    }

  }, options);

  observer.observe(recommeneded_section);
}

